import { RootState } from '@client/redux/types';

import { NAMESPACE } from './constants';

export const getCCFEntriesTabs = (state: RootState) => state[NAMESPACE].tabs;
